import { Injectable } from '@angular/core';
import { SurveyTemplateDocument } from 'app/models/survey-template-document/survey-template-document.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MockResourceService {
  public totalFitnessSurveyUuid = '7809dee7-c179-4380-8afd-e3adeb40ef83';

  constructor() { }

  public async getSurveyTemplateDocumentIdsAsync(): Promise<any> {
    return await this.getSurveyTemplateDocumentIds();
  }

  public getTotalFitnessSurveyAsync(): Promise<SurveyTemplateDocument> {
    return this.getSurveyTemplateDocumentAsync(this.totalFitnessSurveyUuid);
  }

  public async getSurveyTemplateDocumentAsync(templateUuid: string): Promise<SurveyTemplateDocument> {
    if (templateUuid === this.totalFitnessSurveyUuid) {
      return await this.getTotalFitnessSurvey();
    }
    return null;
  }

  private getTotalFitnessSurvey(): SurveyTemplateDocument {
    const json1 = `{
      "uuid": "7809dee7-c179-4380-8afd-e3adeb40ef83",
      "document": "{\"id\": \"7809dee7-c179-4380-8afd-e3adeb40ef83\", \"name\": \"Marine Total Fitness Self Check\", \"type\": \"SurveyTemplateDocument\", \"version\": 1, \"survey_choices\": [{\"id\": \"46fedad8-5b45-11ec-bf63-0242ac130002\", \"label\": \"Agree\", \"score_weight\": 4}, {\"id\": \"46fedd1c-5b45-11ec-bf63-0242ac130002\", \"label\": \"Somewhat agree\", \"score_weight\": 3}, {\"id\": \"46fee078-5b45-11ec-bf63-0242ac130002\", \"label\": \"Neutral\", \"score_weight\": 2}, {\"id\": \"46fee19a-5b45-11ec-bf63-0242ac130002\", \"label\": \"Somewhat disagree\", \"score_weight\": 1}, {\"id\": \"46fee294-5b45-11ec-bf63-0242ac130002\", \"label\": \"Disagree\", \"score_weight\": 0}], \"survey_template\": [{\"id\": \"892955d2-5b45-11ec-bf63-0242ac130002\", \"category\": \"Physical Fitness\", \"questions\": [{\"id\": \"c2bb4507-fbd4-4e8f-8649-062bd4195753\", \"order\": 1, \"question\": \"I have the physical fitness necessary to perform all of my duties with confidence (both deployed and in garrison).\"}, {\"id\": \"fe6a3d6e-c29f-4baa-b88a-3696df33ff8f\", \"order\": 2, \"question\": \"My duties are not affected by an unreported medical or dental condition.\"}, {\"id\": \"55ffa6b3-2004-46c2-a455-b5fd1ff5b626\", \"order\": 3, \"question\": \"In the past 30 days, poor physical health did not keep me from my usual activities or from performing my duties.\"}, {\"id\": \"d31e5e6b-2016-4d5d-a13a-fd759fa22948\", \"order\": 4, \"question\": \"I have the necessary knowledge to make good choices regarding nutrition, alcohol use, tobacco use, and safe sex practices.\"}, {\"id\": \"073da3bd-de5e-4760-a22e-da1e503f0c33\", \"order\": 5, \"question\": \"I meet my body composition standards (height and weight or body fat).\"}, {\"id\": \"0f3d58ec-ade7-4cd3-8093-b3a0544012c9\", \"order\": 6, \"question\": \"Please indicate your most recent PFT/CFT classification.\"}]}, {\"id\": \"89295834-5b45-11ec-bf63-0242ac130002\", \"category\": \"Mental Fitness\", \"questions\": [{\"id\": \"6e33f4f0-e51a-42f3-9d2b-2ae024e92dce\", \"order\": 1, \"question\": \"I feel pride in my accomplishments.\"}, {\"id\": \"fd9e23b7-d80b-485e-a3a0-18b6213dbf1c\", \"order\": 2, \"question\": \"I look forward to beginning each day.\"}, {\"id\": \"94c99602-20c6-4028-8821-affc5106076f\", \"order\": 3, \"question\": \"I am making a real contribution toward mission accomplishment.\"}, {\"id\": \"97aea63b-d665-4552-bbee-6405de4b7e0b\", \"order\": 4, \"question\": \"I usually know what I can and cannot control.\"}, {\"id\": \"a40eb498-7ed5-4501-8e2f-ce23df8be9f2\", \"order\": 5, \"question\": \"I am comfortable seeking assistance and asking for help in times of emotional challenge or crisis.\"}, {\"id\": \"b63d1390-5c60-4567-bfaa-55fb17dceeff\", \"order\": 6, \"question\": \"I am currently engaged in activities (reading and education) that contribute to growth\"}]}, {\"id\": \"8929594c-5b45-11ec-bf63-0242ac130002\", \"category\": \"Spiritual Fitness\", \"questions\": [{\"id\": \"66c99cdf-9f3c-47c9-81d6-80d535b343c3\", \"order\": 1, \"question\": \"My life has meaning/purpose.\"}, {\"id\": \"b6beb624-7b8d-49c9-833e-23b084a0e91a\", \"order\": 2, \"question\": \"I am hopeful about life/the future.\"}, {\"id\": \"f2fa4800-2be8-430a-9353-daf5c3a21be7\", \"order\": 3, \"question\": \"My decisions are always moral.\"}, {\"id\": \"83d6866d-8e17-43a9-b26b-a0082c997687\", \"order\": 4, \"question\": \"I have no problem forgiving myself or others.\"}, {\"id\": \"720189cb-360c-4900-bc50-ec84aec42ac2\", \"order\": 5, \"question\": \"I am respectful of people of other beliefs.\"}, {\"id\": \"17a53d43-8d39-4df4-8e0c-d8b087eebbe2\", \"order\": 6, \"question\": \"I am engaged in core values/beliefs.\"}]}, {\"id\": \"89295a50-5b45-11ec-bf63-0242ac130002\", \"category\": \"Social Fitness\", \"questions\": [{\"id\": \"91095d4d-339a-4a21-aa84-c29e9cda0687\", \"order\": 1, \"question\": \"I am respectful of the members of my unit.\"}, {\"id\": \"8d14425f-e048-4c6b-a9f7-59650c2f4699\", \"order\": 2, \"question\": \"I can depend on my spouse/significant other/friends for support.\"}, {\"id\": \"4301526b-e42c-43db-943c-8fe804d58056\", \"order\": 3, \"question\": \"I get along well with members in my unit.\"}, {\"id\": \"b0f346be-125d-45fc-ba78-ebf79d5d2b4e\", \"order\": 4, \"question\": \"I get involved in efforts to improve the community.\"}, {\"id\": \"ca84709c-0689-40df-ac49-caf9a469bf27\", \"order\": 5, \"question\": \"I actively participate in base or community events and activities.\"}, {\"id\": \"950b756d-272d-4249-95c9-213e52a5bb03\", \"order\": 6, \"question\": \"I effectively use USMC and/or local civilian community resources.\"}]}]}",
      "version": 1
    }`;
    const json = `{
        "uuid":"7809dee7-c179-4380-8afd-e3adeb40ef83",
        "document": {
            "id":"7809dee7-c179-4380-8afd-e3adeb40ef83",
            "name":"Marine Total Fitness Self Check",
            "type":"SurveyTemplateDocument",
            "version": 1,
            "survey_choices": [{
                    "id":"46fedad8-5b45-11ec-bf63-0242ac130002",
                    "label":"Agree",
                    "score_weight": 4
                 }, {
                    "id":"46fedd1c-5b45-11ec-bf63-0242ac130002",
                    "label":"Somewhat agree",
                    "score_weight": 3
                 }, {
                    "id":"46fee078-5b45-11ec-bf63-0242ac130002",
                    "label":"Neutral",
                    "score_weight": 2
                 }, {
                    "id":"46fee19a-5b45-11ec-bf63-0242ac130002",
                    "label":"Somewhat disagree",
                    "score_weight": 1
                 }, {
                    "id":"46fee294-5b45-11ec-bf63-0242ac130002",
                    "label":"Disagree",
                    "score_weight": 0
                 }
             ],
            "survey_template": [{
                    "id":"892955d2-5b45-11ec-bf63-0242ac130002",
                    "category":"Physical Fitness",
                    "questions": [{
                            "id":"c2bb4507-fbd4-4e8f-8649-062bd4195753",
                            "order": 1,
                            "question":"I have the physical fitness necessary to perform all of my duties with confidence(both deployed and in garrison)."
                         }, {
                            "id":"fe6a3d6e-c29f-4baa-b88a-3696df33ff8f",
                            "order": 2,
                            "question":"My duties are not affected by an unreported medical or dental condition."
                         }, {
                            "id":"55ffa6b3-2004-46c2-a455-b5fd1ff5b626",
                            "order": 3,
                            "question":"In the past 30 days, poor physical health did not keep me from my usual activities or from performing my duties."
                         }, {
                            "id":"d31e5e6b-2016-4d5d-a13a-fd759fa22948",
                            "order": 4,
                            "question":"I have the necessary knowledge to make good choices regarding nutrition, alcohol use, tobacco use, and safe sex practices."
                         }, {
                            "id":"073da3bd-de5e-4760-a22e-da1e503f0c33",
                            "order": 5,
                            "question":"I meet my body composition standards(height and weight or body fat)."
                         }, {
                            "id":"0f3d58ec-ade7-4cd3-8093-b3a0544012c9",
                            "order": 6,
                            "question":"Please indicate your most recent PFT / CFT classification."
                         }
                     ]
                 }, {
                    "id":"89295834-5b45-11ec-bf63-0242ac130002",
                    "category":"Mental Fitness",
                    "questions": [{
                            "id":"6e33f4f0-e51a-42f3-9d2b-2ae024e92dce",
                            "order": 1,
                            "question":"I feel pride in my accomplishments."
                         }, {
                            "id":"fd9e23b7-d80b-485e-a3a0-18b6213dbf1c",
                            "order": 2,
                            "question":"I look forward to beginning each day."
                         }, {
                            "id":"94c99602-20c6-4028-8821-affc5106076f",
                            "order": 3,
                            "question":"I am making a real contribution toward mission accomplishment."
                         }, {
                            "id":"97aea63b-d665-4552-bbee-6405de4b7e0b",
                            "order": 4,
                            "question":"I usually know what I can and cannot control."
                         }, {
                            "id":"a40eb498-7ed5-4501-8e2f-ce23df8be9f2",
                            "order": 5,
                            "question":"I am comfortable seeking assistance and asking for help in times of emotional challenge or crisis."
                         }, {
                            "id":"b63d1390-5c60-4567-bfaa-55fb17dceeff",
                            "order": 6,
                            "question":"I am currently engaged in activities(reading and education)that contribute to growth"
                         }
                     ]
                 }, {
                    "id":"8929594c-5b45-11ec-bf63-0242ac130002",
                    "category":"Spiritual Fitness",
                    "questions": [{
                            "id":"66c99cdf-9f3c-47c9-81d6-80d535b343c3",
                            "order": 1,
                            "question":"My life has meaning / purpose."
                         }, {
                            "id":"b6beb624-7b8d-49c9-833e-23b084a0e91a",
                            "order": 2,
                            "question":"I am hopeful about life / the future."
                         }, {
                            "id":"f2fa4800-2be8-430a-9353-daf5c3a21be7",
                            "order": 3,
                            "question":"My decisions are always moral."
                         }, {
                            "id":"83d6866d-8e17-43a9-b26b-a0082c997687",
                            "order": 4,
                            "question":"I have no problem forgiving myself or others."
                         }, {
                            "id":"720189cb-360c-4900-bc50-ec84aec42ac2",
                            "order": 5,
                            "question":"I am respectful of people of other beliefs."
                         }, {
                            "id":"17a53d43-8d39-4df4-8e0c-d8b087eebbe2",
                            "order": 6,
                            "question":"I am engaged in core values / beliefs."
                         }
                     ]
                 }, {
                    "id":"89295a50-5b45-11ec-bf63-0242ac130002",
                    "category":"Social Fitness",
                    "questions": [{
                            "id":"91095d4d-339a-4a21-aa84-c29e9cda0687",
                            "order": 1,
                            "question":"I am respectful of the members of my unit."
                         }, {
                            "id":"8d14425f-e048-4c6b-a9f7-59650c2f4699",
                            "order": 2,
                            "question":"I can depend on my spouse / significant other / friends for support."
                         }, {
                            "id":"4301526b-e42c-43db-943c-8fe804d58056",
                            "order": 3,
                            "question":"I get along well with members in my unit."
                         }, {
                            "id":"b0f346be-125d-45fc-ba78-ebf79d5d2b4e",
                            "order": 4,
                            "question":"I get involved in efforts to improve the community."
                         }, {
                            "id":"ca84709c-0689-40df-ac49-caf9a469bf27",
                            "order": 5,
                            "question":"I actively participate in base or community events and activities."
                         }, {
                            "id":"950b756d-272d-4249-95c9-213e52a5bb03",
                            "order": 6,
                            "question":"I effectively use USMC and / or local civilian community resources."
                         }
                     ]
                 }
             ]
         },
        "version": 1
    }`;
    const jsonObj = JSON.parse(json);
    console.log(jsonObj);
    return new SurveyTemplateDocument(jsonObj);
  }

  private getSurveyTemplateDocumentIds(): any {
    const documentsObjJson = {
      documents: [
        '7809dee7-c179-4380-8afd-e3adeb40ef83'
      ]
    };
    return documentsObjJson;
  }
}
